// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 🌟 Conteneur principal */
.quiz-lfit-container {
  display: flex;
  flex-wrap: wrap;
  height: 90vh;
  font-family: Arial, sans-serif;
  max-width: 1200px;
  margin: auto;
  background: linear-gradient(to right, #eef2f3, #dfe9f3);
  align-items: center;
  justify-content: center;
  border-radius: 15px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
  overflow: hidden;
}

/* 📚 Menu latéral avec angles arrondis */
.quiz-lfit-sidebar {
  width: 250px;
  background: #69b0f7;
  color: white;
  padding: 20px;
  overflow-y: auto;
  border-radius: 15px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
  margin: 10px;
  box-sizing: border-box;
}

.quiz-lfit-sidebar h2 {
  text-align: center;
  font-size: 22px;
  margin-bottom: 10px;
}

.quiz-lfit-sidebar ul {
  list-style: none;
  padding: 0;
}

.quiz-lfit-sidebar li {
  margin: 10px 0;
}

.quiz-lfit-sidebar button {
  width: 100%;
  background: #508ddf;
  color: white;
  border: none;
  padding: 12px;
  cursor: pointer;
  text-align: center;
  border-radius: 8px;
  transition: background 0.3s ease, transform 0.1s ease;
  font-size: 16px;
  font-weight: bold;
}

.quiz-lfit-sidebar button:hover {
  background: #3b7acc;
  transform: scale(1.05);
}

/* 🏆 Conteneur principal du quiz */
.quiz-lfit-main {
  flex: 1 1;
  min-width: 0;
  height: calc(100% - 20px);
  background: #f7f9fc;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  text-align: center;
  border-radius: 15px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
  box-sizing: border-box;
  margin: 10px;
  overflow: hidden;
}

/* 🎯 Titre */
.quiz-lfit-main h1 {
  font-size: 26px;
  color: #333;
  font-weight: bold;
}

/* 📌 Sous-menu des niveaux */
.quiz-lfit-levels {
  display: flex;
  justify-content: center;
  gap: 10px;
  flex-wrap: wrap;
  margin-top: 15px;
}

.quiz-lfit-levels button {
  padding: 10px 15px;
  font-size: 16px;
  background-color: #3498db;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.3s ease, transform 0.1s ease;
}

.quiz-lfit-levels button:hover {
  background-color: #2980b9;
  transform: scale(1.05);
}

/* 🎮 Réponses centrées */
.quiz-lfit-answers {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  max-width: 400px;
  margin: 20px auto;
}

.quiz-lfit-answers button {
  padding: 12px;
  font-size: 16px;
  background-color: #3498db;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  width: 100%;
  max-width: 300px;
  transition: background 0.3s ease, transform 0.1s ease;
}

.quiz-lfit-answers button:hover {
  background-color: #2980b9;
  transform: scale(1.05);
}

/* ✅ Réponse correcte */
.quiz-lfit-correct {
  background-color: #2ecc71 !important;
}

/* ❌ Réponse incorrecte */
.quiz-lfit-incorrect {
  background-color: #e74c3c !important;
}

/* 📜 Bloc question */
.quiz-lfit-question-box {
  background: white;
  border-radius: 15px;
  padding: 20px;
  margin-top: 20px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
  max-width: 500px;
  text-align: center;
  box-sizing: border-box;
}

.quiz-lfit-question-box h2 {
  font-size: 20px;
  color: #333;
  font-weight: bold;
}

/* 📱 Responsive */
@media (max-width: 600px) {
  .quiz-lfit-container {
    flex-direction: column;
    height: auto;
    align-items: center;
    justify-content: center;
  }

  .quiz-lfit-sidebar {
    width: 75%;
    text-align: center;
    border-radius: 10px;
    margin: auto;
  }

  .quiz-lfit-main {
    padding: 10px;
    width: 90%;
    height: auto;
  }

  .quiz-lfit-levels {
    flex-direction: column;
    align-items: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/composant/container/QuizLFIT/QuizLFIT.css"],"names":[],"mappings":"AAAA,2BAA2B;AAC3B;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,8BAA8B;EAC9B,iBAAiB;EACjB,YAAY;EACZ,uDAAuD;EACvD,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA,yCAAyC;AACzC;EACE,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;EAC1C,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,qDAAqD;EACrD,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA,mCAAmC;AACnC;EACE,SAAO;EACP,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,0CAA0C;EAC1C,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;;AAEA,aAAa;AACb;EACE,eAAe;EACf,WAAW;EACX,iBAAiB;AACnB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,qDAAqD;AACvD;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,qDAAqD;AACvD;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA,uBAAuB;AACvB;EACE,oCAAoC;AACtC;;AAEA,yBAAyB;AACzB;EACE,oCAAoC;AACtC;;AAEA,qBAAqB;AACrB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,0CAA0C;EAC1C,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,iBAAiB;AACnB;;AAEA,kBAAkB;AAClB;EACE;IACE,sBAAsB;IACtB,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,UAAU;IACV,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,aAAa;IACb,UAAU;IACV,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;AACF","sourcesContent":["/* 🌟 Conteneur principal */\n.quiz-lfit-container {\n  display: flex;\n  flex-wrap: wrap;\n  height: 90vh;\n  font-family: Arial, sans-serif;\n  max-width: 1200px;\n  margin: auto;\n  background: linear-gradient(to right, #eef2f3, #dfe9f3);\n  align-items: center;\n  justify-content: center;\n  border-radius: 15px;\n  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);\n  overflow: hidden;\n}\n\n/* 📚 Menu latéral avec angles arrondis */\n.quiz-lfit-sidebar {\n  width: 250px;\n  background: #69b0f7;\n  color: white;\n  padding: 20px;\n  overflow-y: auto;\n  border-radius: 15px;\n  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);\n  margin: 10px;\n  box-sizing: border-box;\n}\n\n.quiz-lfit-sidebar h2 {\n  text-align: center;\n  font-size: 22px;\n  margin-bottom: 10px;\n}\n\n.quiz-lfit-sidebar ul {\n  list-style: none;\n  padding: 0;\n}\n\n.quiz-lfit-sidebar li {\n  margin: 10px 0;\n}\n\n.quiz-lfit-sidebar button {\n  width: 100%;\n  background: #508ddf;\n  color: white;\n  border: none;\n  padding: 12px;\n  cursor: pointer;\n  text-align: center;\n  border-radius: 8px;\n  transition: background 0.3s ease, transform 0.1s ease;\n  font-size: 16px;\n  font-weight: bold;\n}\n\n.quiz-lfit-sidebar button:hover {\n  background: #3b7acc;\n  transform: scale(1.05);\n}\n\n/* 🏆 Conteneur principal du quiz */\n.quiz-lfit-main {\n  flex: 1;\n  min-width: 0;\n  height: calc(100% - 20px);\n  background: #f7f9fc;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n  text-align: center;\n  border-radius: 15px;\n  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);\n  box-sizing: border-box;\n  margin: 10px;\n  overflow: hidden;\n}\n\n/* 🎯 Titre */\n.quiz-lfit-main h1 {\n  font-size: 26px;\n  color: #333;\n  font-weight: bold;\n}\n\n/* 📌 Sous-menu des niveaux */\n.quiz-lfit-levels {\n  display: flex;\n  justify-content: center;\n  gap: 10px;\n  flex-wrap: wrap;\n  margin-top: 15px;\n}\n\n.quiz-lfit-levels button {\n  padding: 10px 15px;\n  font-size: 16px;\n  background-color: #3498db;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: background 0.3s ease, transform 0.1s ease;\n}\n\n.quiz-lfit-levels button:hover {\n  background-color: #2980b9;\n  transform: scale(1.05);\n}\n\n/* 🎮 Réponses centrées */\n.quiz-lfit-answers {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  width: 100%;\n  max-width: 400px;\n  margin: 20px auto;\n}\n\n.quiz-lfit-answers button {\n  padding: 12px;\n  font-size: 16px;\n  background-color: #3498db;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  width: 100%;\n  max-width: 300px;\n  transition: background 0.3s ease, transform 0.1s ease;\n}\n\n.quiz-lfit-answers button:hover {\n  background-color: #2980b9;\n  transform: scale(1.05);\n}\n\n/* ✅ Réponse correcte */\n.quiz-lfit-correct {\n  background-color: #2ecc71 !important;\n}\n\n/* ❌ Réponse incorrecte */\n.quiz-lfit-incorrect {\n  background-color: #e74c3c !important;\n}\n\n/* 📜 Bloc question */\n.quiz-lfit-question-box {\n  background: white;\n  border-radius: 15px;\n  padding: 20px;\n  margin-top: 20px;\n  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);\n  max-width: 500px;\n  text-align: center;\n  box-sizing: border-box;\n}\n\n.quiz-lfit-question-box h2 {\n  font-size: 20px;\n  color: #333;\n  font-weight: bold;\n}\n\n/* 📱 Responsive */\n@media (max-width: 600px) {\n  .quiz-lfit-container {\n    flex-direction: column;\n    height: auto;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .quiz-lfit-sidebar {\n    width: 75%;\n    text-align: center;\n    border-radius: 10px;\n    margin: auto;\n  }\n\n  .quiz-lfit-main {\n    padding: 10px;\n    width: 90%;\n    height: auto;\n  }\n\n  .quiz-lfit-levels {\n    flex-direction: column;\n    align-items: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
